/**
 * @generated SignedSource<<9376f7057e797d77d7d732816202b0dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type NovaStudioPageDetailQuery$variables = {
  id: string;
};
export type NovaStudioPageDetailQuery$data = {
  readonly viewer: {
    readonly novaAgent: {
      readonly id: string;
      readonly title: string | null;
      readonly description: string | null;
      readonly systemPrompt: string | null;
      readonly userPromptTemplate: string | null;
      readonly agentMd: string | null;
      readonly categoryId: string | null;
      readonly model: string | null;
      readonly currentVersionNumber: number | null;
      readonly versionName: string | null;
      readonly workflowDeclaration: {
        readonly variableGroups: ReadonlyArray<{
          readonly name: string;
          readonly variables: ReadonlyArray<{
            readonly token: string;
            readonly description: string;
            readonly isCustomerData: boolean;
          }>;
        }>;
      } | null;
      readonly versions: ReadonlyArray<{
        readonly versionNumber: number;
        readonly versionName: string | null;
        readonly createdAt: string | null;
        readonly createdBy: string | null;
        readonly createdByName: string | null;
        readonly updatedAt: string | null;
        readonly updatedByName: string | null;
        readonly isCurrent: boolean;
        readonly isRunnable: boolean;
        readonly systemPrompt: string | null;
        readonly userPromptTemplate: string | null;
        readonly agentMd: string | null;
        readonly model: string | null;
        readonly contentHash: string | null;
      }>;
      readonly files: ReadonlyArray<{
        readonly fileId: string;
        readonly filename: string;
        readonly variableToken: string;
        readonly processingStatus: string;
        readonly sizeBytes: number | null;
        readonly mimeType: string | null;
      }>;
    } | null;
  } | null;
};
export type NovaStudioPageDetailQuery = {
  variables: NovaStudioPageDetailQuery$variables;
  response: NovaStudioPageDetailQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "systemPrompt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userPromptTemplate",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "agentMd",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "model",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "versionName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ],
  "concreteType": "NovaAgent",
  "kind": "LinkedField",
  "name": "novaAgent",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "categoryId",
      "storageKey": null
    },
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentVersionNumber",
      "storageKey": null
    },
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "NovaAgenticWorkflow",
      "kind": "LinkedField",
      "name": "workflowDeclaration",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NovaWorkflowVariableGroup",
          "kind": "LinkedField",
          "name": "variableGroups",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "NovaWorkflowVariable",
              "kind": "LinkedField",
              "name": "variables",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "token",
                  "storageKey": null
                },
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isCustomerData",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NovaAgentVersion",
      "kind": "LinkedField",
      "name": "versions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "versionNumber",
          "storageKey": null
        },
        (v7/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdBy",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdByName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedByName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCurrent",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isRunnable",
          "storageKey": null
        },
        (v3/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contentHash",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NovaAgentFile",
      "kind": "LinkedField",
      "name": "files",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fileId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "filename",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "variableToken",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "processingStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sizeBytes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mimeType",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NovaStudioPageDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NovaStudioPageDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1553de01e7a2199e5a7b92a84a316989",
    "id": null,
    "metadata": {},
    "name": "NovaStudioPageDetailQuery",
    "operationKind": "query",
    "text": "query NovaStudioPageDetailQuery(\n  $id: ID!\n) {\n  viewer {\n    novaAgent(id: $id) {\n      id\n      title\n      description\n      systemPrompt\n      userPromptTemplate\n      agentMd\n      categoryId\n      model\n      currentVersionNumber\n      versionName\n      workflowDeclaration {\n        variableGroups {\n          name\n          variables {\n            token\n            description\n            isCustomerData\n          }\n        }\n      }\n      versions {\n        versionNumber\n        versionName\n        createdAt\n        createdBy\n        createdByName\n        updatedAt\n        updatedByName\n        isCurrent\n        isRunnable\n        systemPrompt\n        userPromptTemplate\n        agentMd\n        model\n        contentHash\n      }\n      files {\n        fileId\n        filename\n        variableToken\n        processingStatus\n        sizeBytes\n        mimeType\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "a75ced6731d9ec5c60990f041f740e47";

export default node;
